import React from 'react';
import { Button } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { usePermissions, useTranslate } from 'react-admin';
import { UserRole } from '../../../entities';

interface FPSToggleButtonProps {
  showFPS: boolean;
  onToggle: () => void;
}

export const FPSToggleButton: React.FC<FPSToggleButtonProps> = ({
  showFPS,
  onToggle,
}) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const isAdmin = permissions && permissions.role === UserRole.admin;

  if (!isAdmin) return null;

  return (
    <Button
      variant="contained"
      color={showFPS ? 'secondary' : 'default'}
      onClick={onToggle}
      startIcon={showFPS ? <VisibilityOffIcon /> : <VisibilityIcon />}
      fullWidth
      style={{ marginTop: 15 }}
    >
      {showFPS ? translate('osfc.storage_ui.fps.hide') : translate('osfc.storage_ui.fps.show')}
    </Button>
  );
};
